import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getVersion } from "../../service/commonService";
import "./index.scss";

function Footer({ className }) {
  const version = useSelector((state) => state.common.version);
  const versionDate = useSelector((state) => state.common.versionDate);

  useEffect(() => {
    getVersion();
  }, [])

  return (
    <footer className={`footer-content ${className}`}>
      <div>{version}</div>
      <div className="separator">|</div>
      <div>{versionDate}</div>
    </footer>
  );
}

export default Footer;
